import { Controller } from "@hotwired/stimulus";
import { navigateFrame, debounce } from "../../modules/table_navigation";

export default class extends Controller {
  connect() {
    this._submit = debounce(() => this.#submit());
    this.element
      .querySelectorAll(
        "select:not([data-table--comparison-target]):not([data-table--attachments-filter-target])"
      )
      .forEach((el) => el.addEventListener("change", () => this.#submit()));
    this.element
      .querySelectorAll(
        "input[name]:not([type=submit]):not([type=checkbox]):not([type=radio])"
      )
      .forEach((el) => {
        el.addEventListener("input", this._submit);
        el.addEventListener("change", this._submit);
      });
  }

  #submit() {
    navigateFrame(this.element, { restoreFocus: true });
  }
}
